import { render, staticRenderFns } from "./lists.page.vue?vue&type=template&id=3308176b&scoped=true&"
import script from "./lists.page.vue?vue&type=script&lang=js&"
export * from "./lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308176b",
  null
  
)

export default component.exports